<template>
  <div class="fm-file" @click="$emit('click', file)">
    <div class="fm-file-preview">
      <fm-file-preview :file="file" />
    </div>
    <div
        v-if="editable"
        class="fm-file-remove"
        @click="$emit('delete')"
    >
      <feather-icon icon="TrashIcon" size="11" />
    </div>
  </div>
</template>

<script>
import FmFilePreview from "@/views/menu/file-manager/components/fmFilePreview.vue";

export default {
  name: "fmFile",
  components: { FmFilePreview },
  props: {
    file: { type: Object, default: null },
    editable: { type: Boolean, default: true },
  },
  data() {
    return {
      loading: ''
    }
  }
}
</script>

<style lang="scss">
@import '~@core/scss/base/bootstrap-extended/variables';
.fm-file {
  width: 120px;
  height: 120px;
  position: relative;
  border-radius: 8px;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 3px rgba($primary, 0.9);
    .fm-file-remove {
      visibility: visible;
    }
  }
}
.fm-file-preview {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.fm-file-remove {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: #ff6363;
  color: white;
  top: 0;
  right: 0;
  transform: translate(30%, -30%);
  visibility: hidden;
}
</style>